const BenefitsOffSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31.8" height="29.504">
      <g data-name="グループ 14" stroke="#8c8c8c" strokeMiterlimit="10" strokeWidth="1.5">
        <g data-name="長方形 182" fill="none">
          <path stroke="none" d="M0 5.999h31.8v6.728H0z" />
          <path fill="none" d="M.75 6.749h30.3v5.228H.75z" />
        </g>
        <g data-name="長方形 183" fill="none">
          <path stroke="none" d="M1.961 14.123h27.878v15.38H1.961z" />
          <path d="M2.711 14.873h26.378v13.88H2.711z" />
        </g>
        <path data-name="パス 53" d="M10.139 6.861s-3.076-3.908-.435-5.546 6.14.876 6.2 4.684" fill="none" />
        <path data-name="パス 54" d="M21.66 6.861s3.075-3.908.434-5.546-6.139.876-6.2 4.684" fill="none" />
      </g>
    </svg>
  )
}

export default BenefitsOffSvg
